
import styles from './call_to_action.module.sass'

import BlockWrapper from './layout/block_wrapper'

import Button from './basic/button'
import ScrollAnimation from './layout/scroll_animation'

function CallToAction(props) {
	const fields = props.fields

	return <BlockWrapper {...props} className={styles.call_to_action} >
		<ScrollAnimation styles={styles}>
			<div className={styles.call_to_action_wrapper}>
				{fields.content && <div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>}
				{fields.button_clone && <Button fields={fields.button_clone} button_style={fields.button_clone.button_style} color='purple' className={styles.button}>{fields.button_clone.button?.title}</Button>}
			</div>
		</ScrollAnimation>
	</BlockWrapper>

}

export default CallToAction